import { useEffect, useState } from "react";

/** A key that changes at local midnight and after waking/refocusing on a new day. */
export function useLocalDayKey(): string {
  const [key, setKey] = useState(() => new Date().toDateString());

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const sync = () => setKey(new Date().toDateString());
    const scheduleNextMidnight = () => {
      const now = new Date();
      const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1, 0);
      timeoutId = setTimeout(() => {
        sync();
        scheduleNextMidnight();
      }, nextMidnight.getTime() - now.getTime());
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") sync();
    };

    scheduleNextMidnight();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return key;
}
